module.exports = __webpack_public_path__ + "static/media/amanda.28b04bc4.jpeg";